export enum RegistrationStepIndexes {
    Reseller,
    Company,
    Credits,
    Directors,
    Suppliers,
    Terms,
    Country
}